import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { InputRef } from 'antd';
import { PinInput, PinInputsContainer, PinInputsWrapper, FormLabel } from '../styles';

interface PinInputFieldProps {
	onKeyDown: (index: number, e: React.KeyboardEvent) => void;
	onPinChange: (index: number, value: string) => void;
	pinInputRefs: React.RefObject<(InputRef | null)[]>;
	onPaste: (e: React.ClipboardEvent) => void;
	pinValues: string[];
	anonymous?: boolean;
}

export function PinInputField({
	pinValues,
	pinInputRefs,
	onPinChange,
	onKeyDown,
	onPaste,
	anonymous
}: Readonly<PinInputFieldProps>) {
	return (
		<div className="input-wrapper right-column">
			<FormLabel required>{I18n.get('Access PIN')}</FormLabel>
			<PinInputsWrapper>
				<PinInputsContainer>
					{pinValues.map((value, index) => (
						<Form.Item
							rules={[{ required: true, message: 'Required' }]}
							validateTrigger={['onChange', 'onBlur']}
							name={['pin', index]}
							key={index}
							noStyle
						>
							<PinInput
								onChange={(e) => onPinChange(index, e.target.value)}
								onKeyDown={(e) => onKeyDown(index, e)}
								aria-label={`PIN digit ${index + 1}`}
								ref={(el) => {
									if (pinInputRefs.current) {
										pinInputRefs.current[index] = el;
									}
								}}
								disabled={anonymous}
								inputMode="text"
								onPaste={onPaste}
								maxLength={1}
								value={value}
							/>
						</Form.Item>
					))}
				</PinInputsContainer>
			</PinInputsWrapper>
		</div>
	);
}
